export const ErrorSource = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report',
};
//# sourceMappingURL=error.types.js.map


// WEBPACK FOOTER //
// ./~/@datadog/browser-rum-core/~/@datadog/browser-core/esm/domain/error/error.types.js